module.exports = __webpack_public_path__ + "static/media/delete.f1f29bd6.svg";